export const annotationArrowTypes = [
  'C_region',
  'CDS',
  'D_segment',
  'gene',
  'J_segment',
  'misc_RNA',
  'mRNA',
  'ncRNA',
  'N_region',
  'operon',
  'precursor_RNA',
  'prim_transcript',
  'primer_bind',
  'rep_origin',
  'rRNA',
  'tmRNA',
  'tRNA',
  'V_region',
  'V_segment',
];

export const featureTypes = [
  "3'UTR",
  "5'UTR",
  '-10_signal',
  '-35_signal',
  'assembly_gap',
  'attenuator',
  'C_region',
  'CAAT_signal',
  'CDS',
  'centromere',
  'conflict',
  'D-loop',
  'D_segment',
  'enhancer',
  'exon',
  'gap',
  'GC_signal',
  'gene',
  'iDNA',
  'intron',
  'J_segment',
  'LTR',
  'mat_peptide',
  'misc_binding',
  'misc_difference',
  'misc_feature',
  'misc_recomb',
  'misc_RNA',
  'misc_signal',
  'misc_structure',
  'mobile_element',
  'modified_base',
  'mRNA',
  'ncRNA',
  'N_region',
  'old_sequence',
  'operon',
  'oriT',
  'polyA_signal',
  'polyA_site',
  'precursor_RNA',
  'prim_transcript',
  'primer_bind',
  'propeptide',
  'proprotein',
  'promoter',
  'protein_bind',
  'RBS',
  'regulatory',
  'repeat_region',
  'rep_origin',
  'rRNA',
  'S_region',
  'sig_peptide',
  'source',
  'stem_loop',
  'STS',
  'TATA_signal',
  'telomere',
  'terminator',
  'tmRNA',
  'transit_peptide',
  'tRNA',
  'unsure',
  'V_region',
  'V_segment',
  'variation',
];

export const DNA_BASE_COLORS = {
  A: 'green',
  T: 'red',
  G: 'black',
  C: 'blue',
};
